import { render, staticRenderFns } from "./commonNoRecord.vue?vue&type=template&id=027770ee&scoped=true"
import script from "./commonNoRecord.vue?vue&type=script&lang=js"
export * from "./commonNoRecord.vue?vue&type=script&lang=js"
import style0 from "./commonNoRecord.vue?vue&type=style&index=0&id=027770ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027770ee",
  null
  
)

export default component.exports